import { apiRequest } from '../http'

// 获取用户IP所在国家
export const fetchUserLocation = () => apiRequest.get('/person/location')

// 登录
export const postLogin = (params) => apiRequest.post('/login', params)

// 忘记密码
export const postForgotPassword = (params) => apiRequest.post('/forgotPassword', params)

// 注册
export const postSignup = (params) => apiRequest.post('/signup', params)

// 完善个人信息
export const postProfile = (params) => apiRequest.post('/addMissingParts', params)

// 获取个人信息
export const fetchProfile = () => apiRequest.get('/userInfo')

// 邮箱验证
export const postVerifiedEmail = (params) => apiRequest.post('/learnerEmailVerified', params)

// 家长邮箱验证
export const postParentsVerifiedEmail = (params) => apiRequest.post('/parentsEmailVerified', params)

// 家长邮箱验证-获取用户信息
export const getUserInfoParents = (params) =>
  apiRequest.get('/getUserInfoByParentsCode', { params })

// 家长邮箱验证-获取用户信息
export const getUserInfoLearner = (params) => apiRequest.get('/getUserInfoByLearnerCode', params)

// 重发邮件
export const postResendEmail = (params) => apiRequest.post('/resendEmail', params)

// 退出登录
export const postLogout = () => apiRequest.post('/logout')

// 检查用户是否可以免费考试
export const userFree = () => apiRequest.get('v1/examination/userFree')

// 接口登录 废弃
// export const loginByActiveCode = (params) => apiRequest.post('/loginByActiveCode', params)

// 加密登录
export const encryptPostLogin = (params) => apiRequest.post('/login_enc_pwd', params)

// 加密注册
export const encryptPostSignup = (params) => apiRequest.post('/signup_enc_pwd', params)

// 新登录或注册
export const loginOrSignup = (params) => apiRequest.post('/login_or_signup', params)

// 新获取个人信息
export const addMissingPartsReplenish = (params) =>
  apiRequest.post('/addMissingPartsReplenish', params)

// 获取sso授权页URL 授权页登录页路由不同但是UI复用
export const getLoginUriSSO = (params) => apiRequest.get('/sso_auth_url', { params })

// 获取sso登录页URL 授权页登录页路由不同但是UI复用
export const getLoginErrUriSSO = (params) => apiRequest.get('/sso_login_url', { params })

// 使用 code+ticket 登录
export const loginSSO = (params) => apiRequest.post('/sso_login', params)
